module.exports = __webpack_public_path__ + "static/media/blackEmail.b9ff51a5.svg";